import { gql, TypedDocumentNode } from '@apollo/client';

import {
  DeleteUserSecretMutation,
  DeleteUserSecretMutationVariables,
} from '../generated';

export const DELETE_USER_SECRET: TypedDocumentNode<
  DeleteUserSecretMutation,
  DeleteUserSecretMutationVariables
> = gql`
  mutation DeleteUserSecret($id: ID!) {
    deleteUserSecret(id: $id)
  }
`;
